module.exports = __webpack_public_path__ + "img/can.69e0d46d.png";